/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

/**
 * This component displays a detailed table of the given session.
 *
 * @vue-prop {String} node the session root node
 * @vue-prop {String} eventId the ID of the event
 * @vue-prop {String} userId the ID of the user
 *
 * @category ui.components.organizations.participants
 * @exports SessionsDetails
 * @component
 */
const __vue_script__ = {
    name: 'SessionsDetails',

    props: {
        node: {
            type: String,
            required: true,
        },

        eventId: {
            type: String,
            required: true
        },

        userId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            error: null,
            loading: true,
            sessions: []
        };
    },

    async created() {
        this.sessions = [];

        try {
            this.sessions = await this.$services.userSession.getInEvent(this.eventId, this.userId, this.node);
        } catch (error) {
            this.error = get(error, 'response.data.error') || error.message;
        } finally {
            this.loading = false;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "session-details modal-wrapper" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c("span", {
        staticClass: "close",
        on: {
          click: function ($event) {
            return _vm.$emit("close")
          },
        },
      }),
      _c("h2", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "organization.pax_management.sections.workspaces.sessions_title"
            )
          )
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "loader",
          { staticClass: "in-page", attrs: { status: _vm.loading } },
          [
            !_vm.error && _vm.sessions.length
              ? _c("div", { staticClass: "table-wrapper" }, [
                  _c("table", { staticClass: "table table-striped" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "organization.pax_management.sections.workspaces.device"
                              )
                            )
                          ),
                        ]),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "organization.pax_management.sections.workspaces.activation"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.sessions, function (session) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(session.device))]),
                          _c("td", { staticClass: "still" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$utils.time.tsToFormat(
                                  session.createdMs / 1000,
                                  "llll"
                                )
                              )
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ])
              : _vm._e(),
            !_vm.error && !_vm.sessions.length
              ? _c("div", { staticClass: "alert alert-notice" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "organization.pax_management.sections.workspaces.no_sessions"
                        )
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.error
              ? _c("div", { staticClass: "alert alert-error" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("general.error_occurred")))]),
                  _c("p", [_vm._v(_vm._s(_vm.error))]),
                ])
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/organizations/participants/SessionsDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__